import PromoBanner from "@/pages/public/Home/components/PromoBanner/PromoBanner";
import {
  cashbackPromoTheme,
  dailySpinsPinkTheme,
  mondaySpinsPromoTheme,
  registerPromoTheme,
  thursdaySpinsRedTheme,
} from "@/pages/public/Home/components/PromoBanner/promoBannerThemes";

const CASHBACK_PERCENTAGE = 13;

/**
 * @param {import("./homeLayoutContext").HomeLayoutContext} ctx
 */
const HomePromoRow = ({ctx}) => {
  const {
    t,
    authStatus,
    styles,
    isMonday,
    isDailyPromoActive,
    isThursdayPromoActive,
    countdownText,
    dailyPromoCountdownText,
    thursdayPromoCountdownText,
    handleRegisterPromoClick,
    handleBankAccountModal,
  } = ctx;

  return (
    <div className={styles.promoRow}>
      {authStatus === "unauthenticated" && (
        <PromoBanner
          ariaLabel={t("registerPromoAria")}
          onClick={handleRegisterPromoClick}
          title={t("registerPromoTitle")}
          description={t("registerPromoDesc")}
          tagText={t("registerPromoTag")}
          bottomValue={t("registerPromoCta")}
          badgeMain="🎰"
          themeStyle={registerPromoTheme}
        />
      )}

      {authStatus === "authenticated" && (
        <>
          <PromoBanner
            ariaLabel={t("cashbackBannerAria")}
            title={t("cashbackTitle")}
            description={t("cashbackDesc")}
            tagText={isMonday ? t("cashbackPayday") : t("cashbackActive")}
            bottomLabel={!isMonday ? t("cashbackNextMonday") : undefined}
            bottomValue={!isMonday ? countdownText : undefined}
            badgeMain={`${CASHBACK_PERCENTAGE}%`}
            themeStyle={cashbackPromoTheme}
          />
          <PromoBanner
            ariaLabel={t("mondaySpinsAria")}
            title={t("mondaySpinsTitle")}
            description={t("mondaySpinsDesc")}
            tagText={!isMonday ? t("mondaySpinsTag") : undefined}
            actionText={isMonday ? t("mondaySpinsDeposit") : undefined}
            onActionClick={isMonday ? handleBankAccountModal : undefined}
            bottomLabel={!isMonday ? t("mondaySpinsNextMonday") : undefined}
            bottomValue={!isMonday ? countdownText : undefined}
            badge={
              <div className={styles.customMondayBadge}>
                <span className={styles.customMondayBadgeMain}>40</span>
                <span className={styles.customMondayBadgeSub}>VEs</span>
              </div>
            }
            themeStyle={dailySpinsPinkTheme}
          />
          <PromoBanner
            ariaLabel={t("mondaySpinsAria")}
            title={t("dailySpinsTitle")}
            description={t("dailySpinsDesc")}
            tagText={isDailyPromoActive ? t("active") : t("dailySpinsTag")}
            bottomLabel={!isDailyPromoActive ? t("dailySpinsNextActive") : undefined}
            bottomValue={isDailyPromoActive ? t("active") : dailyPromoCountdownText}
            badge={
              <div className={styles.customMondayBadge}>
                <span className={styles.customMondayBadgeMain}>1</span>
                <span className={styles.customMondayBadgeSub}>Giro</span>
              </div>
            }
            themeStyle={thursdaySpinsRedTheme}
          />
          <PromoBanner
            ariaLabel={t("mondaySpinsAria")}
            title="Hora loca todos los jueves"
            description="Hora loca todos los jueves de 8 a 9 pm por cada 40 ves que deposites te damos un giro gratis."
            tagText={isThursdayPromoActive ? t("active") : "Solo jueves 8:00pm - 9:00pm"}
            bottomLabel={!isThursdayPromoActive ? "Próximo jueves activo en" : undefined}
            bottomValue={isThursdayPromoActive ? t("active") : thursdayPromoCountdownText}
            badge={
              <div className={styles.customMondayBadge}>
                <span className={styles.customMondayBadgeMain}>40</span>
                <span className={styles.customMondayBadgeSub}>VEs</span>
              </div>
            }
            themeStyle={mondaySpinsPromoTheme}
          />
        </>
      )}
    </div>
  );
};

export default HomePromoRow;
